import { Box } from "@mantine/core"
import { ReactNode } from "react"

interface TransformationLayoutProps {
  header: ReactNode
  leftPanel: ReactNode
  rightPanel: ReactNode
  modals?: ReactNode
}

export function TransformationLayout({
  header,
  leftPanel,
  rightPanel,
  modals,
}: TransformationLayoutProps) {
  const panelHeight = "calc(100vh - 160px)"

  return (
    <Box
      h="calc(100vh - 80px)"
      display="flex"
      style={{
        flexDirection: "column",
      }}
    >
      <Box mb="md" style={{ flexShrink: 0 }}>
        {header}
      </Box>

      <Box
        flex={1}
        display="flex"
        mih={0}
        style={{
          gap: "var(--mantine-spacing-md)",
        }}
      >
        <Box w="66.67%" h={panelHeight}>
          {leftPanel}
        </Box>
        <Box w="33.33%" h={panelHeight}>
          {rightPanel}
        </Box>
      </Box>

      {modals}
    </Box>
  )
}
